module.exports = __webpack_public_path__ + "src/app/_content/imgs/Cosy/cosyMotorrad.png?f0b8963a85155c0620bddc5cb62e72f5";